import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-nav',
  templateUrl: './icon-nav.component.html',
  styleUrls: ['./icon-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconNavComponent {}
